"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("../../../assets/styles/config");
exports.StyledContainer = styled_components_1.default.ul `
  align-items: center;
  border-bottom: 1px solid ${config_1.colors.huron};
  display: flex;
  flex-direction: row;
  height: 70px;
  justify-content: start;
  margin: 0;
  padding: 0;
`;
